import React, { useState, useEffect } from 'react';

import { GetDeparture } from './GetDeparture';

export const useDeparture = (cityCode) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        GetDeparture(cityCode).then(data => {
            setData(data);
            setLoading(false);
        });
    }, []);

    return [data, loading];

}